import type { Analytics } from 'firebase/analytics'
import { createContext } from 'react'

export const FirebaseContext = createContext<Analytics | null>(null)
